/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CdsButtonConfig } from '@cds/ng-core/button';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { CdsButtonModule } from '@cds/ng-web-components/button';
import { InternalLoginUrlService } from 'src/app/core/services/internal-login-url.service';

@Component({
  selector: 'app-time-out',
  templateUrl: './time-out.component.html',
  styleUrls: ['./time-out.component.scss'],
  imports: [CdsButtonModule],
})
export class TimeOutComponent implements OnInit {
  private router = inject(Router);
  private authenticationService = inject(AuthenticationService);
  private internalLoginUrlService = inject(InternalLoginUrlService);

  ssoButtonConfig: CdsButtonConfig = {
    buttonType: 'button',
    style: 'secondary',
    size: 'sm',
    fullWidth: true,
  };

  toLogin() {
    this.router.navigate([this.getLoginPath()]);
  }

  ngOnInit() {
    this.authenticationService.currentUserValue().then(data => {
      if (data.token !== undefined) {
        this.authenticationService.deleteSession(false);
      } else {
        this.router.navigate([this.getLoginPath()]);
      }
    });
  }

  private getLoginPath(): string {
    return localStorage.getItem('loginType') === 'sso' ? this.internalLoginUrlService.getLoginPath() : '/user/login';
  }
}
